import { SVGAttributes } from 'react';

/* eslint-disable @typescript-eslint/no-empty-interface */
interface ModusignGray16hProps extends SVGAttributes<SVGElement> {}

function ModusignGray16h(props: ModusignGray16hProps) {
  return (
    <svg
      fill="none"
      height="16"
      {...props}
      viewBox="0 0 108 16"
      width="108"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path
          clipRule="evenodd"
          d="M38.3643 12.956C41.229 12.9498 42.0744 11.476 42.0676 8.09873L42.0661 7.3942C42.0582 3.80019 40.9446 2.67305 38.1552 2.67819L35.2074 2.68435L35.2283 12.9606L38.3643 12.956ZM32.4264 0.743815L38.495 0.722761C42.9999 0.713518 44.7901 2.5421 44.8 7.1888L44.8016 7.97189C44.811 12.5636 43.2738 14.8626 38.5431 14.8718L32.4546 14.8662L32.4264 0.743815ZM46.6063 9.69691L46.5885 0.9807L49.357 0.975565L49.3742 9.47302C49.381 12.5571 50.9841 13.2812 53.0953 13.2776C55.1872 13.2735 56.637 12.5433 56.6308 9.45864L56.6135 0.960673L59.3062 0.956052L59.3224 8.79725C59.3312 13.1677 57.77 15.327 52.9771 15.3357C49.0406 15.3434 46.6141 13.3084 46.6063 9.69691ZM61.515 14.848L61.5108 12.8074L66.0323 12.7986C68.1807 12.794 69.1265 11.9606 69.1239 10.8781C69.1223 10.0072 68.645 9.31245 67.0801 8.95094L65.1378 8.48108C63.0255 7.99274 61.2211 6.94006 61.2159 4.49835C61.2107 2.11107 63.4249 0.748746 66.837 0.723071L71.9635 0.704071L71.7695 1.77883C71.644 2.41352 71.0699 2.87362 70.4012 2.87516L66.8976 2.87311C65.3333 2.87619 64.1653 3.25259 64.1679 4.45521C64.1705 5.6029 64.812 5.98443 66.2645 6.40088L68.1687 6.87074C70.3939 7.413 72.0518 8.31728 72.0571 10.7631C72.0628 13.3892 70.0697 14.8496 66.2624 14.8383L61.515 14.848ZM88.9683 2.85637C85.4815 2.86356 84.3924 4.86982 84.3982 7.54825L84.3997 8.2954C84.4055 11.229 85.2572 13.1038 88.6881 13.0972C89.5356 13.0951 90.6854 12.9657 91.2317 12.8009L91.2239 9.17503L88.9861 9.17914C88.5668 9.17966 88.227 8.85255 88.2259 8.4474L88.2238 7.2951L93.8386 7.2838L93.8533 14.2351C92.7234 14.6931 90.7272 15.0978 88.7106 15.1019C84.3945 15.1101 81.5361 13.2754 81.5267 8.31954L81.5251 7.75468C81.5136 2.34287 84.9304 0.76898 88.7754 0.761278L93.2802 0.752034L92.9644 1.93309C92.8196 2.47278 92.3166 2.8497 91.741 2.85072L88.9683 2.85637Z"
          fill="black"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M0.0288372 14.9338L0 1.01075L4.10609 1.00249L7.62783 10.7036H7.66708L11.4972 0.987936L15.3762 0.979675L15.4047 14.9035L12.8269 14.9086L12.8033 3.65532H12.7649L8.62271 14.6211L6.67861 14.6242L2.6346 3.67538H2.59655L2.61938 14.9287L0.0288372 14.9338Z"
          fill="black"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M96.1167 14.7095L96.0879 0.816815L98.7994 0.812094L105.248 10.3975L105.288 0.79872L107.971 0.793213L108 14.6859L105.256 14.6915L98.8074 4.88692L98.8282 14.704L96.1167 14.7095Z"
          fill="black"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M19.7605 8.00899C19.7662 10.7562 20.471 13.6026 23.903 13.5959C27.5153 13.5887 28.0904 10.7393 28.0847 7.99256C28.0789 5.2448 27.4923 2.50423 23.9704 2.51142C20.448 2.51861 19.7547 5.26123 19.7605 8.00899ZM30.8406 7.98691C30.8505 12.7471 28.688 15.4907 23.9971 15.5C19.3061 15.5092 17.1227 12.7738 17.1133 8.01412C17.1034 3.38026 19.2748 0.509779 23.9662 0.500022C28.6572 0.490779 30.8312 3.35305 30.8406 7.98691Z"
          fill="black"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M78.8128 0.537154L81.6184 0.531647L75.3852 14.9051L72.5787 14.9106L78.8128 0.537154Z"
          fill="black"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export default ModusignGray16h;
